import {Flash} from '@primer/react'
import {memo} from 'react'

import styles from './ErrorMessage.module.css'

type ErrorMessageProps = {children: React.ReactNode}

export const ErrorMessage = memo(({children}: ErrorMessageProps) => (
  <Flash variant="danger" full className={styles.flash}>
    {children}
  </Flash>
))
ErrorMessage.displayName = 'MarkdownEditor.ErrorMessage'
